import { Box, Button, Flex, Stack, Table, Text } from '@mantine/core'
import { transformValuesToLabelforLanguagesToString } from '@v2/commons/utils/objectManipulation'
import { getPhoneWithMask } from '@v2/commons/utils/phone'

import { LocationDto } from 'src/api/generated'
import { Icons } from 'src/common/components'

import { ILocation, LocationResponseModel } from '../../location.types'
import { openCreateUpdateLocationModal } from '../CreateUpdateLocationModal/CreateUpdateLocationModal.component'
import { openLocationDeleteModal } from '../DeleteLocationModal/DeleteLocationModal.component'
import classes from './locationsTable.module.scss'

interface LocationsTableProps {
  locations: LocationResponseModel | LocationDto[] | undefined
  handleEditClinic: (clinicId: string) => void
  clinicLocationTable?: boolean
  clinicId?: string
  clinicName?: string
}

const LocationsTable = ({
  locations,
  handleEditClinic,
  clinicLocationTable = false,
  clinicId = '',
  clinicName = '',
}: LocationsTableProps) => {
  const newLocations: ILocation[] = !locations
    ? []
    : 'records' in locations
    ? locations.records
    : locations

  return (
    <Table.ScrollContainer
      minWidth={500}
      mah={clinicLocationTable ? 350 : ''}
      type="native"
    >
      <Table
        layout="fixed"
        classNames={{
          table: classes.table,
          thead: classes['table-head'],
          th: classes['table-th'],
          td: classes['table-td'],
        }}
        highlightOnHover={true}
        withTableBorder={true}
        withColumnBorders={true}
        stickyHeader
      >
        <Table.Thead>
          <Table.Tr>
            <Table.Th>
              <Flex justify="center" align="center" gap="xs">
                Location Name
              </Flex>
            </Table.Th>
            {!clinicLocationTable && (
              <Table.Th>
                <Flex justify="center" align="center" gap="xs">
                  Specialty
                </Flex>
              </Table.Th>
            )}
            <Table.Th>
              <Flex justify="center" align="center" gap="xs">
                Address
              </Flex>
            </Table.Th>
            <Table.Th>
              <Flex justify="center" align="center" gap="xs">
                Phone Number
              </Flex>
            </Table.Th>
            {clinicLocationTable && (
              <Table.Th>
                <Flex justify="center" align="center" gap="xs">
                  Languages
                </Flex>
              </Table.Th>
            )}
            {!clinicLocationTable && (
              <Table.Th>
                <Flex justify="center" align="center" gap="xs">
                  Provider
                </Flex>
              </Table.Th>
            )}
            <Table.Th>
              <Flex justify="center" align="center" gap="xs">
                Business Days
              </Flex>
            </Table.Th>
            <Table.Th></Table.Th>
          </Table.Tr>
        </Table.Thead>
        <Table.Tbody>
          {newLocations.length > 0 ? (
            newLocations.map((location, idx: number) => (
              <Table.Tr key={`${location.name}-${idx}`}>
                <Table.Td
                  onClick={() => handleEditClinic(location?.clinic?.id ?? '')}
                >
                  {location.name ?? 'Not Location name found'}
                </Table.Td>
                {!clinicLocationTable && (
                  <Table.Td
                    onClick={() => handleEditClinic(location?.clinic?.id ?? '')}
                  >
                    {location.metaData?.specialty ?? 'Not Specialty found'}
                  </Table.Td>
                )}
                <Table.Td
                  onClick={() => handleEditClinic(location?.clinic?.id ?? '')}
                >
                  {
                    <Box>
                      <Text
                        style={{ textAlign: 'center' }}
                      >{`${location.address.streetAddress}, ${location.address.state} ${location.address.zipCode}`}</Text>
                    </Box>
                  }
                </Table.Td>
                <Table.Td
                  onClick={() => handleEditClinic(location?.clinic?.id ?? '')}
                >
                  {getPhoneWithMask(location.phoneNumber)}
                </Table.Td>
                {clinicLocationTable && (
                  <Table.Td>
                    {transformValuesToLabelforLanguagesToString(
                      location.languages,
                    )}
                  </Table.Td>
                )}
                {!clinicLocationTable && (
                  <Table.Td>
                    {location.provider ?? 'Any Available Provider'}
                  </Table.Td>
                )}
                <Table.Td
                  onClick={() => handleEditClinic(location?.clinic?.id ?? '')}
                >
                  {location.businessDays}
                </Table.Td>
                <Table.Td>
                  <Flex justify="center" align="center" gap="md">
                    {clinicLocationTable && (
                      <Flex
                        onClick={() =>
                          openCreateUpdateLocationModal(
                            clinicId,
                            clinicName,
                            location,
                          )
                        }
                        c="blue"
                        justify="center"
                        align="center"
                        gap="xs"
                      >
                        <Icons.Edit />
                      </Flex>
                    )}
                    <Flex
                      onClick={() => openLocationDeleteModal(location.id)}
                      c="red"
                      justify="center"
                      align="center"
                      gap="xs"
                    >
                      <Icons.Trash />
                    </Flex>
                  </Flex>
                </Table.Td>
              </Table.Tr>
            ))
          ) : (
            <Table.Td colSpan={6}>
              <Stack justify="center" align="center" gap="xs">
                <Text>No Locations added yet</Text>
                <Button
                  size="md"
                  variant="transparent"
                  leftSection={'+'}
                  onClick={() =>
                    openCreateUpdateLocationModal(clinicId, clinicName, null)
                  }
                >
                  Add a location
                </Button>
              </Stack>
            </Table.Td>
          )}
        </Table.Tbody>
      </Table>
    </Table.ScrollContainer>
  )
}

export default LocationsTable
